import ApiConfig from '../config/api'
import BaseAction from './action.abstract'

export default class UserAction extends BaseAction {
  fetchUserInfo(uid: any): Promise<any> {
    return this.FetchSimpleData(ApiConfig.api.user.user_info, { uid })
  }

  fetchUserList(condition?: any): Promise<any> {
    return this.FetchSimpleList(ApiConfig.api.user.user_list, condition)
  }

  fetchUserCertList(condition?: any): Promise<any> {
    return this.FetchSimpleList(ApiConfig.api.user.user_cert_list, condition)
  }

  setUserStatus(uid: any, action: string): Promise<any> {
    return this.CallRequest(ApiConfig.api.user.user_set_status, 'put', {
      uid, action,
    })
  }

  editUserStatus(uid: any, formData: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.user.user_edit_data, 'put', {
      uid,
      ...formData,
    })
  }

  setAuthStatus(uid: any, action: string): Promise<any> {
    return this.CallRequest(ApiConfig.api.user.cert_set_status, 'put', {
      uid, action,
    })
  }
}

export const userAction = new UserAction()
